<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="elevation-12 pa-4">
          <v-card-title class="text-h5 text-center">
            Aguardando Aprovação
          </v-card-title>
          
          <v-card-text class="text-center mt-4">
            <v-icon icon="mdi-account-clock" size="64" color="warning" class="mb-4"></v-icon>
            <p class="text-body-1 mb-4">
              Sua conta está cadastrada no sistema, mas ainda aguarda aprovação por um administrador.
            </p>
            <p class="text-body-1 mb-4">
              Por favor, entre em contato com o administrador do sistema ou tente novamente mais tarde.
            </p>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              variant="elevated"
              @click="onLogout"
              class="px-6"
            >
              <v-icon left>mdi-logout</v-icon>
              Logout
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'InfoView',
  
  methods: {
    ...mapActions('user', ['logout']),
    
    async onLogout() {
      const { success } = await this.logout();
      
      if (success) {
        this.$router.push({ name: 'SignPage' });
      }
    }
  }
}
</script> 